import React from "react";
import { Link } from "react-router-dom";
import * as Api from "../api/recipes";
import { toast } from "react-toastify";
import { getMealName } from "../misc/utils";

class MealRecipes extends React.Component {
    state = {
        recipes: []
    };

    async componentDidMount() {
        // This binding is necessary to make `this` work in the callback
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        await this.getRecipeList();
    }

    async getRecipeList() {
        this.setState({
            recipes: await Api.getRecipes()
        });
    }

    async onDeleteClicked(recipeId) {
        try {
            if (window.confirm("Estas seguro?")) {
                await Api.deleteRecipe(recipeId);

                var array = [...this.state.recipes]; // make a separate copy of the array
                var index = array.findIndex(r => r.id === recipeId);
                if (index !== -1) {
                    array.splice(index, 1);
                    this.setState({ recipes: array });
                    toast.success("Receta borrada exitosamente");
                }
            }
        } catch {
            toast.error("Hubo un error al borrar la receta");
        }
    }

    render() {
        return (
            <>
                <h2> Meal Recipes </h2>
                <Link to="/Recipe" className="btn btn-primary">
                    Agregar Receta
                </Link>
                <br />
                <br />
                <form>
                    <table className="table table-sm">
                        <thead className="table-dark">
                            <tr>
                                <th>MealTime</th>
                                <th>Name</th>
                                <th />
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.recipes.map(recipe => {
                                return (
                                    <tr key={recipe.id}>
                                        <td>{getMealName(recipe.mealTime)}</td>
                                        <td>{recipe.name}</td>

                                        <td>
                                            <Link
                                                to={`/recipe/${recipe.id}`}
                                                className="btn btn-primary btn-sm"
                                            >
                                                Editar
                                            </Link>
                                        </td>
                                        <td>
                                            <input
                                                type="button"
                                                onClick={event => this.onDeleteClicked(recipe.id)}
                                                className="btn btn-danger btn-sm"
                                                value="Borrar"
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </form>
            </>
        );
    }
}
export default MealRecipes;
